import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'split-card',
  templateUrl: './split-card.component.html',
  styleUrls: ['./split-card.component.scss']
})
export class SplitCardComponent {

  @Input() public theme: string = "primary";

  @Input() public buttom: boolean = false;

}
